<template>
  <el-table class="list" id="listMediaServers" :data="clients">
    <el-table-column prop="client_name" label="Полное имя">
      <template slot-scope="scope">
        <router-link class="link" :to="'/client/edit/' + scope.row.id_account">
          {{ scope.row.client_name || "Нет данных" }}
        </router-link>
      </template>
    </el-table-column>
    <el-table-column prop="login" label="Логин / телефон" />
    <el-table-column align="center" prop="cameras_count" label="Доступно камер" />
    <el-table-column align="center" prop="register_dt" label="Дата регистрации" />
    <el-table-column align="center" width="120px" v-if="$can('delete', 'clients')" label="Действия">
      <template slot-scope="scope">
        <el-button size="small" type="danger" @click="onRemove(scope.row.id_account)">
          Удалить <fa :icon="['fas', 'trash-alt']" />
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { mapActions, mapState } from "vuex";

library.add(faTrashAlt);

export default {
  name: "ClientsTable",
  components: { fa },
  computed: {
    ...mapState("clients", {
      clients: (state) => state.data,
    }),
  },
  methods: {
    ...mapActions("client", {
      deleteClient: "DELETE_CLIENT",
    }),
    onRemove(id) {
      const client = this.clients.find((c) => c.id_account === id);
      this.$confirm(`Вы точно хотите удалить клиента "${client.client_name} ?"`, "Подтверждение", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        confirmButtonClass: "el-button--danger",
        type: "warning",
      }).then(() => this.remove(id));
    },
    remove(id) {
      this.deleteClient(id)
        .then(() => {
          this.$message({
            message: "Клиент удален",
            type: "success",
          });
          this.$emit("clientDeleted");
        })
        .catch((e) => {
          this.$message.error(e.response.data.error || "Ошибка при удалении клиента");
        });
    },
  },
};
</script>
